import { get } from 'lodash'
import { baseApi } from './baseApi'
import { buildQs } from 'utils/queryString'

export const iotApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // `lessor/v1/managements/iot/devices?${qs}`
        getManagementsIotDevices: builder.query({
            query: (data) => {
                const qs = buildQs(data)
                return {
                    url: `lessor/v1/managements/iot/devices?${qs}`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['GET_MANAGEMENTS_IOT_DEVICES'],
        }),
        // /lessor/v1/iot/securities 取得IoT憑證列表
        // org_id: string, providerIds: string[]
        getIotSecurities: builder.query({
            query: (data) => {
                const qs = buildQs(data)
                return {
                    url: `lessor/v1/iot/securities?${qs}`,
                    method: 'GET',
                }
            },
            providesTags: ['GET_IOT_SECURITY'],
            keepUnusedDataFor: 0,
        }),
        // /lessor/v1/iot/securities 創建IoT憑證
        // { "org_id": "string", "display_name": "string", "provider_id": "string", "inputs": [ { "key": "string", "value": "string" } ] }
        createIotSecurity: builder.mutation({
            query: (data) => {
                return {
                    url: `lessor/v1/iot/securities`,
                    method: 'POST',
                    data,
                }
            },
            invalidatesTags: ['GET_IOT_SECURITY'],
        }),
        // /lessor/v1/iot/securities/{securityId} 刪除IoT憑證
        deleteIotSecurity: builder.mutation({
            query: (securityId) => {
                return {
                    url: `lessor/v1/iot/securities/${securityId}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['GET_IOT_SECURITY'],
        }),
        // /lessor/v1/iot/securities/{securityId}/sync 利用IoT憑證進行廠商同步行為
        syncIotSecurity: builder.mutation({
            query: (securityId) => {
                return {
                    url: `lessor/v1/iot/securities/${securityId}/sync`,
                    method: 'POST',
                }
            },
            invalidatesTags: [
                'DEVICE_HISTORIES',
                'GET_IOT_DEVICES',
                'GET_MANAGEMENTS_IOT_DEVICES',
            ],
        }),
        // /lessor/v1/iot/devices 創建IoT裝置
        createIotDevice: builder.mutation({
            query: (data) => {
                return {
                    url: `lessor/v1/iot/devices`,
                    method: 'POST',
                    data,
                }
            },
            invalidatesTags: [
                'GET_MANAGEMENTS_IOT_DEVICES',
                'DEVICE_HISTORIES',
            ],
        }),
        // /lessor/v1/iot/devices/{iot_device_id}/sync-bind-origin-houses IoT裝置同步綁定物件
        syncBindOriginHouses: builder.mutation({
            query: (data) => {
                const {
                    iotDeviceId,
                    org_id,
                    add_origin_house_ids,
                    remove_origin_house_ids,
                } = data
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/sync-bind-origin-houses`,
                    method: 'POST',
                    data: {
                        org_id,
                        add_origin_house_ids,
                        remove_origin_house_ids,
                    },
                }
            },
            invalidatesTags: ['BIND_ORIGIN_HOUSES', 'DEVICE_HISTORIES'],
        }),
        // /lessor/v1/iot/devices/{iot_device_id}/bind-origin-houses IoT裝置綁定物件列表
        getIotDeviceBindOriginHouses: builder.query({
            query: (iotDeviceId) => {
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/bind-origin-houses`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['BIND_ORIGIN_HOUSES'],
        }),
        // /lessor/v1/iot/devices/{iot_device_id}/histories IoT裝置歷程紀錄
        getIotDeviceHistories: builder.query({
            query: (iotDeviceId) => {
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/histories`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['DEVICE_HISTORIES'],
        }),
        // power-sensor/data 取得詳情資料
        getPowerSensorData: builder.query({
            query: (iotDeviceId) => {
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/power-sensor/data`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['POWER_SENSOR_DATA'],
        }),
        // /lessor/v1/iot/devices/{iot_device_id}/power-sensor/set-mode 更新模式
        setPowerSensorMode: builder.mutation({
            query: (data) => {
                const iotDeviceId = get(data, 'iot_device_id')
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/power-sensor/set-mode`,
                    method: 'POST',
                    data: {
                        mode: get(data, 'mode'),
                    },
                }
            },
            invalidatesTags: ['POWER_SENSOR_DATA', 'DEVICE_HISTORIES'],
        }),
        // /lessor/v1/iot/devices/{iot_device_id}/power-sensor/add-credit 加值
        addPowerSensorCredit: builder.mutation({
            query: (data) => {
                const { iotDeviceId, credit_amount, bill_amount } = data
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/power-sensor/add-credit`,
                    method: 'POST',
                    data: {
                        credit_amount,
                        bill_amount,
                    },
                }
            },
            invalidatesTags: [
                'POWER_SENSOR_DATA',
                'DEVICE_HISTORIES',
                'CREDIT_HISTORIES',
            ],
        }),
        // /lessor/v1/iot/devices/{iot_device_id}/credit-histories IoT裝置加值紀錄
        getIotDeviceCreditHistories: builder.query({
            query: (iotDeviceId) => {
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/credit-histories`,
                    method: 'GET',
                }
            },
            providesTags: ['CREDIT_HISTORIES'],
            keepUnusedDataFor: 0,
        }),
        // /lessor/v1/iot/devices/{iot_device_id} 刪除IoT裝置
        deleteIotDevice: builder.mutation({
            query: (iotDeviceId) => {
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['IOT_DEVICES_DETAIL', 'DEVICE_HISTORIES'],
        }),
        // /lessor/v1/iot/devices/{iot_device_id} 更新IoT裝置詳情資料(適用所有類型裝置)
        updateIotDevice: builder.mutation({
            query: (data) => {
                const iotDeviceId = get(data, 'iot_device_id')
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}`,
                    method: 'PUT',
                    data,
                }
            },
            invalidatesTags: ['IOT_DEVICES_DETAIL', 'DEVICE_HISTORIES'],
        }),
        // /lessor/v1/iot/devices/{iot_device_id} 取得IoT裝置詳情資料(適用所有類型裝置)
        getIotDeviceDetail: builder.query({
            query: (iotDeviceId) => {
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['IOT_DEVICES_DETAIL'],
        }),
        // /lessor/v1/iot/devices 取得IoT裝置列表
        getIotDevices: builder.query({
            query: ({ org_id, in_origin_house_ids }) => {
                const qs = buildQs({ org_id, in_origin_house_ids })
                return {
                    url: `lessor/v1/iot/devices?${qs}`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['GET_IOT_DEVICES'],
        }),
        // /lessor/v1/origin-houses/{origin_house_id}/sync-bind-iot-devices 同步綁定IoT裝置
        syncBindIotDevices: builder.mutation({
            query: (data) => {
                const { origin_house_id, sync_iot_device_ids } = data
                return {
                    url: `lessor/v1/origin-houses/${origin_house_id}/sync-bind-iot-devices`,
                    method: 'POST',
                    data: {
                        sync_iot_device_ids,
                    },
                }
            },
            invalidatesTags: ['GET_IOT_DEVICES'],
        }),
        // /lessor/v1/iot/devices/{iot_device_id}/credit-config 更新IoT裝置加值設定
        updateCreditConfig: builder.mutation({
            query: (data) => {
                const iotDeviceId = get(data, 'iot_device_id')
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/credit-config`,
                    method: 'PUT',
                    data,
                }
            },
            invalidatesTags: ['GET_CREDIT_CONFIG'],
        }),
        // /lessor/v1/iot/devices/{iot_device_id}/credit-config IoT裝置加值設定
        getCreditConfig: builder.query({
            query: (iotDeviceId) => {
                return {
                    url: `lessor/v1/iot/devices/${iotDeviceId}/credit-config`,
                    method: 'GET',
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['GET_CREDIT_CONFIG'],
        }),
    }),
})

export const {
    useGetManagementsIotDevicesQuery,
    useGetIotSecuritiesQuery,
    useCreateIotSecurityMutation,
    useDeleteIotSecurityMutation,
    useSyncIotSecurityMutation,
    useCreateIotDeviceMutation,
    useSyncBindOriginHousesMutation,
    useGetIotDeviceBindOriginHousesQuery,
    useGetIotDeviceHistoriesQuery,
    useGetPowerSensorDataQuery,
    useLazyGetPowerSensorDataQuery,
    useSetPowerSensorModeMutation,
    useAddPowerSensorCreditMutation,
    useGetIotDeviceCreditHistoriesQuery,
    useDeleteIotDeviceMutation,
    useUpdateIotDeviceMutation,
    useGetIotDeviceDetailQuery,
    useGetIotDevicesQuery,
    useSyncBindIotDevicesMutation,
    useGetCreditConfigQuery,
    useUpdateCreditConfigMutation,
} = iotApi
